import { ConfluenceEdition } from '../components/__types__/ContentRestrictionsQuery.ts';

export enum parentPageTypes {
	FREE = 'free',
	RESTRICTED = 'restricted',
	NOT_RESTRICTED = 'not_restricted',
}

export const getRestrictionType = (
	userCanEditRestrictions: boolean,
	edition: ConfluenceEdition | string,
): string => {
	if (!userCanEditRestrictions) {
		return parentPageTypes.NOT_RESTRICTED;
	}
	if (edition === ConfluenceEdition.FREE) {
		return parentPageTypes.FREE;
	}

	return parentPageTypes.RESTRICTED;
};
